import { getDocs, query, updateDoc, where } from "firebase/firestore";
import {
  getSubscriptionsCollectionRef,
  getSubscriptionsRef,
} from "../../../firebase/collectionReferences";

// getAllSubscriptions
export async function getAllSubscriptions(selectedPackages) {
  const subscriptionCollRef = getSubscriptionsCollectionRef();
  const subscription_query = query(
    subscriptionCollRef,
    where("prod_id", "in", selectedPackages)
  );

  const subscription_snapshot = await getDocs(subscription_query);
  const subscriptions = subscription_snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));

  return subscriptions;
}

// get Subscriptions by userId
export async function getSubscriptionsByUserId(userId) {
  const subscriptionCollRef = getSubscriptionsCollectionRef();
  const subscription_query = query(
    subscriptionCollRef,
    where("userId", "==", userId)
  );

  const subscription_snapshot = await getDocs(subscription_query);
  const subscriptions = subscription_snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));

  return subscriptions;
}

export async function updateSubscription(data) {
  const subscriptionRef = getSubscriptionsRef(data.id);
  await updateDoc(subscriptionRef, data);
  return data.id;
}
